import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoConvenio, TipoConvenioProps } from '../../interfaces/catalogos/TipoConvenioInterface';

export const TipoConvenios = () => {

    return new Promise<TipoConvenioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoConvenio/', token)
            .then( ({ data } : { data : TipoConvenioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoConvenio = () => {

    return new Promise<TipoConvenioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoConvenio/ObtenerTipoConvenios', token)
            .then( ({ data } : { data : TipoConvenioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoConvenio = ( params: TipoConvenioProps ) => {

    return new Promise<TipoConvenioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoConvenio/Actualizar', params, token)
            .then( ({ data } : { data : TipoConvenioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoConvenio });
            });

        }

    });

}

export const AgregarTipoConvenio = ( params: TipoConvenioProps ) => {

    return new Promise<TipoConvenioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoConvenio/Agregar', params, token)
            .then( ({ data } : { data : TipoConvenioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoConvenio });
            });

        }

    });

}
